import React from "react";
// import { useField } from 'formik';
import { ErrorMessage, FormikProvider } from "formik";
import { useField, Form, FormikProps, Formik } from "formik";
import Select from "react-select";
import "./DropDown.css";

function Dropdown({ label, onChange, value, options, ...props }) {
  const [field, meta, helpers] = useField(props);

  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : "";
  };

  return (
    <>
      <div class="form-floating mb-2">
        <select
          className={`form-select ${
            meta.touched && meta.error && "is-invalid"
          }`}
          name={props.name}
        >
          {options?.map((item, i) => {
            return <option value={item.value}>{item.value}</option>;
          })}
        </select>

        <label for="floatingSelect">{label}</label>
      </div>
    </>
  );
}

export default Dropdown;
